import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Events from './pages/Events';
import Media from './pages/Media';
import MilestoneProjects from './pages/MilestoneProjects';
import EventManagement from './pages/expertise/EventManagement';
import AVProduction from './pages/expertise/AVProduction';
import Advertisements from './pages/expertise/Advertisements';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/media" element={<Media />} />
            <Route path="/milestone-projects" element={<MilestoneProjects />} />
            <Route path="/event-management" element={<EventManagement />} />
            <Route path="/av-production" element={<AVProduction />} />
            <Route path="/advertisements" element={<Advertisements />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
